import { PageBack, PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC } from 'react';

type Props = {
  backTo: string;
  title: string;
};
const Head: FC<Props> = ({ backTo, title }) => {
  return (
    <PageHeadContainer>
      <PageTitle>
        <PageBack href={backTo} />
        <h1>{title}</h1>
      </PageTitle>
    </PageHeadContainer>
  );
};

export default Head;
